<template>
	<div class="search__page">
		<header class="header container">
			<div class="row justify-content-between align-items-center pt-4 pt-sm-5">
				<div class="header__link col-8 col-sm-4 ">
					<img src="../assets/img/logo.png" class="header__logo img-fluid" />
				</div>
				<div class="col-4 text-right pt-2">
					<b-button v-if="isLoggedIn" to="/logout" class="header__logout" variant="outline-primary">Logout</b-button>
				</div>
			</div>
		</header>
		<main class="main-content container">
			<b-form class="search-form" @submit="onSubmit">
				<b-input-group class="input-group-lg search__input">
					<b-form-input class="search-form__input" id="search" type="search" v-model="searchInput" @update="onSearchChange"/>
					<b-input-group-prepend class="search-form__prepend" is-text>
						<span class="fe fe-search"></span>
					</b-input-group-prepend>
					<b-input-group-append class="search-form__append" is-text>
						<b-spinner class="search-form__spinner" :class="{ 'is-visible': isSearching }" label="Loading..." />
					</b-input-group-append>
				</b-input-group>
				<div class="search-form__results text-secondary mt-3" v-show="$store.state.search.count">{{ $store.state.search.count }} results</div>
			</b-form>

			<b-navbar toggleable="md" type="light" class="search-nav bg-transparent border-0 mb-3 mb-md-5 lead">
				<b-form-select @change="onTherapeuticAreaClick" v-if="screenWidth < 768" v-model="selected">
					<option :value="null" >All</option>
					<option v-for="(category, idx) in categories.dropdown" :key="idx" :value="category.title" >{{ category.title }}</option>
				</b-form-select>
 				<b-navbar-nav v-if="screenWidth >= 768">
					<b-nav-item @click="onTherapeuticAreaClick(null)">All</b-nav-item>
						<b-nav-item v-for="(category, idx) in categories.visible" :key="idx" @click="onTherapeuticAreaClick(category.title)" :active="($store.state.search.params.therapeuticarea === category.title)">{{ category.title }} <b-badge class="category__badge" variant="light">{{ category.count }}</b-badge></b-nav-item>
						<b-nav-item-dropdown v-if="categories.dropdown.length" text="" right>
						<b-dropdown-item v-for="(category, idx) in categories.dropdown" :key="idx" @click="onTherapeuticAreaClick(category.title)">{{ category.title }} <b-badge variant="light">{{ category.count }}</b-badge></b-dropdown-item>
					</b-nav-item-dropdown>
				</b-navbar-nav>
			</b-navbar>

			<div class="row">
				<div class="col-12 ">
					<PublicationPreview v-for="(publication, idx) in $store.state.search.results" :key="idx" v-bind="publication" />
				</div>
			</div>

			<Pagination :currentPage="$store.state.search.params.page" :totalPages="$store.state.search.pages" :nbLinks="10" @change="onPaginationChange"/>

		</main>
		<router-view></router-view>
	</div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { debounce, isNil, isEmpty } from 'lodash'

import PublicationPreview from '@/components/PublicationPreview.vue'
import Pagination from '@/components/Pagination.vue'

export default {
	name: 'search-results',
	components: {
		PublicationPreview,
		Pagination
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize)
	},
	computed: {
		spliceCut() {
			let theSpliceCut = 0;
			if ( this.screenWidth > 768 ) {
				theSpliceCut = 2;
			}
			if ( this.screenWidth > 1200 ) {
				theSpliceCut = 3;
			}
			if ( this.screenWidth > 1360 ) {
				theSpliceCut = 4;
			}
			return theSpliceCut
		},
		...mapState({
			isLoggedIn: state => state.isLoggedIn,
			isSearching: state => state.search.isSearching,
		}),
		categories() {
			return {
				visible: this.$store.state.search.therapeuticAreas.slice(0, this.spliceCut),
				dropdown: this.$store.state.search.therapeuticAreas.slice(this.spliceCut),
			};
		}
	},
	data() {
		return {
			searchInput: this.$store.state.search.params.search,
			screenWidth: window.innerWidth,
			selected: this.$store.state.search.params.therapeuticarea
		};
	},
	beforeCreate() {
		this.$store.commit('setParams', {
			page: this.$route.query.page || 1,
			search: (!isEmpty(this.$route.query.search) ? decodeURI(this.$route.query.search) : null),
			therapeuticarea: (!isEmpty(this.$route.query.therapeuticarea) ? decodeURI(this.$route.query.therapeuticarea) : null),
		})
	},
	beforeMount () {
		this.search();
	},
	mounted() {
		this.attachResizeEvent();
	},
	beforeDestroy() {
		this.detachResizeEvent();
	},
	methods: {
		attachResizeEvent() {
			window.addEventListener('resize', this.onResize)
		},
		detachResizeEvent() {
			window.removeEventListener('resize', this.onResize)
		},
		onResize() {
			this.screenWidth = window.innerWidth;
		},
		...mapActions([ 'logout', 'search' ]),
		...mapMutations([ 'setParams', 'setSearchParam', 'setTherapeuticAreaParam', 'setPageParam', 'toggleIsSearching' ]),
		onSearchChange: debounce( function() {
			this.toggleIsSearching()
			this.$router.push({
				name: 'search',
				query: { search: isEmpty(this.searchInput) ? null : encodeURI(this.searchInput) }
			})
		}, 250),
		onPaginationChange (nextPage) {
			window.scroll({ top: 0 });
			this.toggleIsSearching()
			this.$router.push({
				name: 'search',
				query: Object.assign( {}, this.$route.query, {page: nextPage} )
			})
		},
		onTherapeuticAreaClick ( _id ) {
			this.toggleIsSearching()
			const query = Object.assign( {}, this.$route.query);
			delete query.therapeuticarea;
			if ( !isNil(_id) ) {
				query.therapeuticarea = encodeURI(_id);
			}

			this.$router.push({
				name: 'search',
				query,
				params: this.$route.query,
			})

			let regex= /%20/ig;
			this.selected = query.therapeuticarea ? query.therapeuticarea.replace(regex, " ") : null;
		},
		onSubmit( event ) {
			this.toggleIsSearching()
			event.preventDefault();
			this.search();
		}
	},
	watch: {
		'$route' (to, from) {

			// Avoid search when opening a publication detail
			if ( (to.name === 'publication' && from.name === 'search') || (to.name === 'search' && from.name === 'publication') ) return;

			if ( from.query.search !== to.query.search ) this.setSearchParam( (!isEmpty(to.query.search) ? decodeURI(to.query.search) : null) );
			else if ( from.query.therapeuticarea !== to.query.therapeuticarea ) this.setTherapeuticAreaParam( !isEmpty(to.query.therapeuticarea) ? decodeURI(to.query.therapeuticarea) : null );
			else if ( from.query.page !== to.query.page ) this.setPageParam( to.query.page );
		}
	}
}
</script>

<style lang="scss" scoped>

.header {

	&__logout {
		border: none;
		border-bottom: 1px solid;
		border-radius: 0;
		padding: .25rem .1rem;

		@media (min-width: 1024px) {
			font-size: 1.0625rem;
		}

		&:hover,
		&:active {
			background-color: transparent;
			color: #0C4FA4;
		}
	}
}

.search {
	&__page {
		background-color: #f8f8f8;
	}

	&__input {
		height: 50px;

		input {
			height: 100%;
		}
	}

	.pub-card {
		&__footer {
			justify-content: flex-end;
		}
	}

	&__pagination {
		justify-content: center;

		.page-item {
			display: none;
		}

		li:last-child {
			display: none;
		}

		li {
			a.page-link {
				border: none;
			}
		}
	}
}

.search-form {
	&__input {
		order: 2;
		border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
		border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;

		&:focus {
			~ .search-form__prepend,
			~ .search-form__append {
				> .input-group-text {
					border-color: #2C7BE5;
				}
			}
		}
	}

	&__prepend {
		order: 1;
		> .input-group-text {
			border-top-left-radius: 0.5rem !important;
			border-bottom-left-radius: .5rem !important;
			padding-right: 0;
		}

		.fe {
			font-size: 1.5rem;
		}
	}
	&__append {
		order: 2;
	}

	&__spinner {
		opacity: 0;
		transition: opacity .1s ease-out;

		&.is-visible {
			opacity: 1;
		}
	}

	&__results {
		padding: 0 0.5rem;
	}
}

.main-content {
	padding-bottom: 2rem;
}

.page-link {
	border: none!important;
	display: none!important;
}

.page-item:first-child .page-link {
	border: none!important;
}

.page-link.active {
	span {
		border-bottom: 2px solid;
	}
}

.page-item:first-child .page-link {
	display: none!important;
}

.page-item.disabled .page-link {
  display: none!important;
}

.navbar-nav {
	@media( max-width: 767px) {
		flex-direction: row;
	}
}
</style>
